module.exports = __webpack_public_path__ + "static/media/probably_no.aaf0fb98.svg";